import {authStoreKey} from '@blesk-frontend/auth';
import axios, {AxiosError} from 'axios';

export const getPrivateAxios = () => {
  const authState = JSON.parse(localStorage.getItem(authStoreKey) ?? '{}')?.state;
  const instance = axios.create({
    baseURL: import.meta.env.VITE_API_END_POINT,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${authState?.token}`,
    },
  });

  instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      if (error?.response?.status === 401) {
        if (error.config?.url?.includes('/auth/') || authState?.noRedirect) {
          return Promise.reject(error);
        }

        window.localStorage.removeItem(authStoreKey);
        if (window.location.pathname === '/auth/app') {
          location.href = '/auth/signin?redirect=app';
        } else if (window.location.pathname === '/auth/extension') {
          location.href = '/auth/signin?redirect=extension';
        } else {
          location.href = '/auth/signin';
        }
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

null;
